import { createFileRoute } from '@tanstack/react-router';

import {
  ResetPasswordPage as SharedResetPasswordPage,
  verifyResetToken,
} from '@/routes/-components/reset-password-page';

export const Route = createFileRoute('/participants/reset-password/$token')({
  beforeLoad: async ({ params }) => {
    const result = await verifyResetToken({ data: { token: params.token } });
    return { tokenValid: result.valid };
  },
  component: ResetPasswordPage,
});

function ResetPasswordPage() {
  const { tokenValid } = Route.useRouteContext();
  const params = Route.useParams();

  return (
    <SharedResetPasswordPage
      token={params.token}
      tokenValid={tokenValid}
      loginPath="/participants/login"
    />
  );
}
